import {
  Overlay,
  OverlayPositionBuilder,
  OverlayRef,
  ViewportRuler
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { AfterViewInit, Component, ComponentRef, OnInit } from '@angular/core';
// import * as GSAPImport from 'gsap';
import { from, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GlobalUtilsService } from './global-utils.service';
import { LoadingIndicatorComponent } from './loading-indicator.component';
import {
  ActiveBreakpoint,
  breakpointTest,
  getImagesPathsByActiveScreen,
  preloadImages
} from './variables';
// const GSAP = GSAPImport.gsap;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  ActiveBreakpoint = ActiveBreakpoint;

  private overlayRef: OverlayRef;
  private portal: ComponentPortal<LoadingIndicatorComponent>;
  loadingIndicatorRef: ComponentRef<LoadingIndicatorComponent>;

  constructor(
    public globalUtilsService: GlobalUtilsService,
    private viewportRuler: ViewportRuler,
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder
  ) {
    // this.initializeOverlayAndLoadingIndicator();
    // this.globalUtilsService.initialLoadingIsFinished.emit();
  }

  ngOnInit() {
    this.updateViewportInfo();
    this.viewportRuler
      .change()
      .pipe(distinctUntilChanged(), debounceTime(100))
      .subscribe(() => {
        this.updateViewportInfo();
        this.globalUtilsService.viewportChanged.emit();
      });
  }

  ngAfterViewInit() {}

  private initializeOverlayAndLoadingIndicator() {
    // const positionStrategy = this.overlayPositionBuilder
    //   .global()
    //   .top('0px')
    //   .bottom('0px')
    //   .left('0px')
    //   .right('0px');

    // this.overlayRef = this.overlay.create({
    //   width: '100%',
    //   height: '100%',
    //   positionStrategy
    // });

    // this.portal = new ComponentPortal(LoadingIndicatorComponent);
    // this.loadingIndicatorRef = this.overlayRef.attach(this.portal);

    // from(
    //   preloadImages(
    //     ...getImagesPathsByActiveScreen(
    //       breakpointTest({
    //         width: window.innerWidth,
    //         height: window.innerHeight
    //       })
    //     )
    //   )
    // ).subscribe({
    //   complete: () => {
    //     this.loadingIndicatorRef.instance.leave().subscribe(() => {
    //       this.overlayRef.detach();
    //       this.globalUtilsService.initialLoadingIsFinished.emit();
    //     });
    //   }
    // });
  }


  private updateViewportInfo() {
    const viewportSize = this.viewportRuler.getViewportSize();
    const breakpoint = breakpointTest(viewportSize);
    this.globalUtilsService.activeScreen = breakpoint;
  }
}
